import { render, staticRenderFns } from "./TipePaketMembership.vue?vue&type=template&id=3097c37f"
import script from "./TipePaketMembership.vue?vue&type=script&lang=js"
export * from "./TipePaketMembership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports